"use strict"

import React from "react"
import { FormattedMessage } from "react-intl"

import { ConfirmEditedResource } from "./ModalParts"
import EditResourceModal from "./EditResourceModal"

/*
NOTE: Disabling all form fields

Disabling all form fields in the UI (for now). Things get complicated when column/tag/unit
registrations are managed by our source_tag_registration.json files and changes are ALSO allowed in the UI.
This can lead to tag registrations (which are shared between LanzaLake and LTPM) getting out of sync and
changes made in the UI could be overwritten by a bootstrap command if the .json was not also updated with
new assignments. While tag registrations are managed by .json files, best not to introduce this potential
outlet for error introduction.

All tag changes must be made by a developer by updating the associated .json file(s) and rerunning the
bootstrap command.
*/

const disable_fields = true // DONT set to 'false' until the above has been fully addressed

export default function EditSourceTagsModal(props) {
  const table_info = [
    {
      header_id: "general.observation.type",
      key: "observation_type",
      style: (tag) => {
        return ""
      },
      content: (tag, idx, updateFormValue, list) => {
        return (
          <select
            className={"form-select form-select-sm"}
            name={"observation_type"}
            value={tag.observation_type}
            disabled={disable_fields}
            onChange={(e) => updateFormValue(e, "observation_type", e.target.value, idx, tag.warning)}
          >
            {props.observation_types
              .filter((ot) => ot !== "Computed")
              .map((ot, idx) => {
                return (
                  <option key={idx} value={ot}>
                    {ot}
                  </option>
                )
              })}
          </select>
        )
      },
    },
    {
      header_id: "general.tag",
      key: "tag",
      style: (tag) => {
        return ""
      },
      content: (tag, idx, updateFormValue, list) => {
        return (
          <select
            className={"form-select form-select-sm"}
            name={"tag"}
            value={tag.tag}
            disabled={true} // DONT CHANGE - This should always be disabled
            onChange={(e) => e.preventDefault()}
          >
            <option value={tag.tag}>{tag.tag}</option>
          </select>
        )
      },
    },
    {
      header_id: "general.units",
      key: "units",
      style: (tag) => {
        return ""
      },
      content: (tag, idx, updateFormValue, list) => {
        return (
          <select
            className={"form-select form-select-sm"}
            name={"units"}
            value={tag.units}
            disabled={disable_fields}
            onChange={(e) => updateFormValue(e, "units", e.target.value, idx, tag.warning)}
          >
            {props.units.map((unit, idx) => {
              return (
                <option key={idx} value={unit.name}>
                  {unit.name}
                </option>
              )
            })}
          </select>
        )
      },
    },
    {
      header_id: "general.status",
      key: "status",
      style: (tag) => {
        return ""
      },
      content: (tag, idx, updateFormValue, list) => {
        if (tag["status"] === "Error") {
          return (
            <h5 className={"table_warning"}>
              <span className={"fa fa-times-circle-o text-danger"} />
            </h5>
          )
        } else {
          return (
            <h5>
              <span className={"fa fa-check-circle-o text-success"} />
            </h5>
          )
        }
      },
    },
  ]

  return (
    <EditResourceModal
      editable_fields={["observation_type", "units"]}
      fields_to_complete={[]}
      fields_to_search={["tag", "label", "status"]}
      resources={props.source}
      step_into_resources={"tags"}
      table_title={
        <h6>
          <FormattedMessage id={"sourceregistration.edit.source.tags"} description={"Edit Source Tags"} />:{" "}
          {props.source.name}
        </h6>
      }
      additionalValidationCheck={false}
      submitData={(data, loaderRef) => props.submitData(data, loaderRef, props.source.id)}
      ModalPart={ConfirmEditedResource}
      modal_title_id={"navigation.source.registration"}
      resource_name={"Edit SourceTags"}
      table_info={table_info}
      table_row_style={(tag) => {
        if (tag.edited) {
          return "table_edited"
        } else {
          return "table_okay"
        }
      }}
      initial_tag_state={(tag) => {
        return { edited: false, warning: false, complete: false }
      }}
      warning={props.warning}
      show={props.show}
      onHide={props.onHide}
      readOnly={disable_fields}
    />
  )
}
